import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { API_URL_WS_FORMULAIRE, APP_URL_APPLICATION } from '@amo/core/constants/constants.js'
import { postPay, POST_PAY_EMBEDDED, postPayEmbedded } from '../../../../../../redux/actions/app/pay/pay.action';
import { setStep } from '../../../../../../redux/actions/app/ui/ui.actions';
import {
    getImmatriculationVehiculeDemandeTarifInit,
    getIsChequePaiement,
    getIsSendMailPaiement,
    getLibelleFormuleDevisInit,
    getToken,
} from '../../../../../../redux/selectors/init/init.selectors';
import { getPayEmbeddedData } from '../../../../../../redux/selectors/pay/pay.selectors';
import { getLoadingEntity } from '../../../../../../redux/selectors/ui/ui.selectors';
import { getMarqueVehicule, getModeleVehicule } from '../../../../../../redux/selectors/vehicule/vehicule.selectors';
import { getSlugStep } from '../../../../../../utils/function';
import Paiement from './Paiement';

const mapStateToProps = (state) => {
    return {
        formule: getLibelleFormuleDevisInit(state),
        marque: getMarqueVehicule(state),
        modele: getModeleVehicule(state),
        immatriculation: getImmatriculationVehiculeDemandeTarifInit(state),
        url_pay: {
            uri: `${API_URL_WS_FORMULAIRE}/pay/${getToken(state)}`,
            uriEmbedded: `${API_URL_WS_FORMULAIRE}/pay-embedded/${getToken(state)}`,
            token: getToken(state),
            url_return: `${APP_URL_APPLICATION}/paiement`,
        },
        sendMailPaiement: getIsSendMailPaiement(state),
        isCheque: getIsChequePaiement(state),
        form: getFormValues('devis')(state),
        payEmbeddedData: getPayEmbeddedData(state),
        payEmbeddedLoading: getLoadingEntity(state, POST_PAY_EMBEDDED),
    };
};

const mapDispatchToProps = {
    postPay,
    postPayEmbedded,
    setStep,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { url_pay, form } = stateProps;
    const { postPay, postPayEmbedded, setStep } = dispatchProps;

    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        postPay: () => postPay({ query: url_pay.uri, form, url_pay }),
        postPayEmbeddedSubmit: () => postPayEmbedded({ query: url_pay.uriEmbedded, form, url_pay }),
        goToValidation: () => setStep({ step: getSlugStep('validation') }),
    };
};

const PaiementContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(Paiement);

export default PaiementContainer;
